<div id="content">
  <!-------------------- Filters -------------------->
  <section id="filters_section">
    <p class="subheading-01-semi-bold" id="filter_subtitle">Filtros:</p>
    <div id="buttonsContainer">
      <qr-input-autocomplete
        [config]="officeDropdownConfig"
        (selectedChange)="dropdownChangeOffice($event)"
        class="dropdown"
      ></qr-input-autocomplete>
      <qr-input-autocomplete
        [config]="regionDropdownConfig"
        (selectedChange)="dropdownChangeRegion($event)"
        class="dropdown"
      ></qr-input-autocomplete>
      <qr-input-autocomplete
        [config]="versionDropdownConfig"
        (selectedChange)="dropdownChangeVersion($event)"
        class="dropdown"
      ></qr-input-autocomplete>

      <qr-button
        [config]="cleanFiltersConfig"
        class="button"
        (click)="cleanFilters()"
      ></qr-button>

      <qr-button
        [config]="selectAllConfig"
        class="button"
        (click)="selectAll()"
      ></qr-button>
    </div>
  </section>

  <!-------------------- Tables -------------------->

  <!---------- Offices ---------->
  <section id="tables_section">
    <div
      class="offices_table"
      *ngIf="officesFull && officesFull.length > 0; else noData"
    >
      <!-- Table Header -->
      <app-table-header
        [tableHeader]="statsTableHeader"
        [orderByColumnDefault]="statsTableHeader[3]"
        [isCheckboxColumnVisible]="false"
        [isStickyEnabled]="false"
        (orderByChange)="sortBy($event)"
      >
      </app-table-header>

      <!-- Table Items -->
      <app-offices-table
        [officesFull]="officesFull"
        [allSelected]="allSelected"
        [preselectedOffices]="value"
        (selectedOfficeEmmited)="checkedOfficesFunction($event)"
      ></app-offices-table>
    </div>
    <!------------ No Data ------------>
    <ng-template #noData>
      <div class="offices_table">
        <div id="title-no-data">Cargando oficinas...</div>
      </div>
    </ng-template>
  </section>
</div>
